import { render, staticRenderFns } from "./ImportacionSorteo.vue?vue&type=template&id=b89bda7e&"
import script from "./ImportacionSorteo.vue?vue&type=script&lang=js&"
export * from "./ImportacionSorteo.vue?vue&type=script&lang=js&"
import style0 from "./ImportacionSorteo.vue?vue&type=style&index=0&id=b89bda7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports